<template>
    <div class="rental-sidebar-right">
        <app-menu ></app-menu>
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="container-fluid xyz">
                <div class="page-name">Dashboard</div>


                <!--page content-->
                <div class="admin-page-content">
                </div>
            </div>
            <footer-div></footer-div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import Sidebar from '@/components/Sidebar'
    import Footer from '@/components/Footer';


    export default {
        name: 'Home',
        components: {
            'sidebar':Sidebar,
            'footer-div':Footer,
        },
        data: () => ({

        }),
        mounted: function() {
        },
        beforeMount:function () {

        },
        methods:{

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue